/**
 * @module sagas/View.js
 */
import { all, put, select, takeLatest } from 'redux-saga/effects';

import { openModal } from '../actions/Modal';
import {
  DefaultSignupModalBody,
  TimedoutSignupModalBody,
} from '../components/Onboarding/SignupModalBody';
import ViewActions from '../constants/ViewActions';
import { isAnonTimedOut } from '../lib/ListenerUtils';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';

const spawn = taskManagerSpawnFactory();

// WORKERS

// throw up the appropriate signup or login modal based on listener state
export function* openSignupLoginModal() {
  const timedOut = yield select(isAnonTimedOut);

  const modalConfig = {
    modalType: 'ModalCustom',
    body: timedOut ? TimedoutSignupModalBody : DefaultSignupModalBody,
  };

  yield put(openModal(modalConfig));
}

/**
 * Watch for OPEN_SIGNUP_LOGIN_MODAL action and execute Saga
 */
export function* watchOpenSignupLoginModal() {
  yield takeLatest(ViewActions.OPEN_SIGNUP_LOGIN_MODAL, openSignupLoginModal);
}

/**
 * Root View Saga
 */
export default function* viewSaga() {
  yield all([spawn(watchOpenSignupLoginModal)]);
}
